import service from './server'
import qs from 'qs'
export function queryPostApi(reqParam) {
	// debugger
	return service({
		url: reqParam.url,
		method: "post",
		params: reqParam.data,
		paramsSerializer: params => {
			return qs.stringify(params, {
				indices: false
			})
		}
	});
}
export function queryNoneReqbody(reqParam) {

	return service({
		url:reqParam.url,
		method: "post",
		data: reqParam.data,
	});
}

export function authorityManagement(permissionName) {
	 let permissionList = JSON.parse(sessionStorage.permission)
	 if(permissionList.indexOf(permissionName)==-1){
		return false
	 }else{
		return true
	 }
}

export default {
	queryNoneReqbody,
	queryPostApi,
	authorityManagement
}
